import React, {useState} from 'react';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {CSVLink, CSVDownload} from "react-csv";
import {Button} from "primereact/button";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const FileExport = (data) => {

    const file_data = data.file_data
    let pdf_content = data.pdf_content
    let pdf_name = pdf_content.pdf_name
    let data_widths = pdf_content.widths
    let body_text = pdf_content.body_text
    let body_cell = pdf_content.body_cell
    let csv_content = data.csv_content
    let csv_name = csv_content.csv_name


    const export_pdf = () => {

        if (file_data) {
            const docDefinition = {
                content: file_data.map(report =>
                    [{
                        table: {
                            headerRows: 1,
                            widths: data_widths,
                            canvas: [
                                {
                                    type: 'line',
                                    x1: 0,
                                    y1: 5,
                                    x2: 510,
                                    y2: 5,
                                    lineWidth: 1,
                                },
                            ],
                            body: [
                                body_text,
                                body_cell.map(cell =>
                                    report[cell]
                                )
                            ],
                        }
                    }]
                )
            };
            pdfMake.createPdf(docDefinition).download(pdf_name,
                function () {
                    setTimeout(function () {
                    }, 300)
                });
        }
    }

    const export_excel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(file_data);
            const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
            const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            saveAsExcelFile(excelBuffer, 'Yapay Zeka Portal Rapor');
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

    return (
        <div>

            {
                file_data ?
                    <div>
                        <CSVLink
                            data={file_data}
                            filename={csv_name}
                            asyncOnClick={true}>

                            <Button tooltip='CSV' type="button" icon="pi pi-file"
                                    className="p-mr-2"
                                    data-pr-tooltip="CSV"
                                    tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                            />

                        </CSVLink>

                        <Button tooltip='EXCEL' type="button" icon="pi pi-file-excel" onClick={() => export_excel()}
                                className="p-button-success p-mr-2"
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                                data-pr-tooltip="EXCEL"/>

                        <Button tooltip='PDF' type="button" icon="pi pi-file-pdf" onClick={() => export_pdf()}
                                className="p-button-danger p-mr-2" data-pr-tooltip="PDF"
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                        />

                    </div>
                    :
                    null
            }

        </div>
    )
}
export default FileExport;



// WEBPACK FOOTER //
// ./src/pages/FileExport.js